import { AssetActivityControlRequest, BULLJSJOBNAMES, BULLJSQUEUENAMES } from '@gtpl/shared-models/common-models';
import { Process, Processor, OnQueueEvent, BullQueueEvents, InjectQueue } from '@nestjs/bull';
import { JobManagementApiService } from '@gtpl/shared-services/job-management-api';
import { Job, Queue } from 'bull';
import { DeviceRequest } from '@gtpl/shared-models/warehouse-management';

@Processor(BULLJSQUEUENAMES.ASSET_ACTIVITY_CONTROLLER_JOB)
export class AssetActivityControlJobProcessor {
  constructor(
    private JobManagementApi: JobManagementApiService
    
  ) { }

  @Process({name:BULLJSJOBNAMES.ASSET_ACTIVITY_CONTROLLER_JOB})
  async assetActivityControlJobJob(job: Job) {
    try {
      console.log('its working');
      const reqObj: AssetActivityControlRequest = job.data;
      console.log(reqObj);
      if (reqObj.assetControl) {
        // we should call api to on the bulb.
        console.log('we should call api to on the bulb');
        const deviceRequest = new DeviceRequest(true,169,'192.168.0.124','FzHzpbLABOtcs2MBwlW6L7q30DDgqsT-O2uykUbS','lights',2,2,'state');
        // await this.JobManagementApi.triggerToControlTheBulb(deviceRequest);
        // plug action
        await this.JobManagementApi.controlSmartPlug();

      }
      return true;
    } catch (error) {
      throw new Error(error);
    }
  }


  @OnQueueEvent(BullQueueEvents.ERROR)
  onError(job: Job, error: Error) {
  }

  @OnQueueEvent(BullQueueEvents.FAILED)
  onFailed(job: Job, error: Error) {
  }

  @OnQueueEvent(BullQueueEvents.COMPLETED)
  onCompleted(job: Job) {
    job.progress(100);
  }

}
